<script>
    import {onMount} from "svelte"

    export let inSVG = false;
        
    let canvas = document.createElement("CANVAS")
    let context 
    let size = 600;
    export let w = 1200;
    export let h = 1800;
        let dataURL
        
    let dpr = window.devicePixelRatio;
    
    let step = 40;
    const lines = [];	
        
    onMount(()=>{
        context = canvas.getContext('2d');
        
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        context.scale(dpr, dpr);

        context.lineWidth = 6;
        context.strokeStyle = "rgba(255,255,255,1)";
        context.fillStyle = "rgba(255,255,255,.3)";
    // 	context.fillStyle="rgba(255,255,255,.2)"
    
        
        // Create the lines
    for(var i = step; i <= h+(step*2); i += step) {
        
      var line = [];
      for(var j = 0; j <= w + step; j+= step) {
        var distanceToCenter = Math.abs(j - w / 2);
        var variance = Math.max(w / 2-20 - distanceToCenter, 0);
        var random = Math.random() * variance / 2 * -1;
        var point = {x: j, y: i + random};
        line.push(point);
      } 
      lines.push(line);
    
    }
    
    // Do the drawing
    for(var i = 0; i < lines.length; i++) {
      // console.log(i)
      context.beginPath();
      context.moveTo(lines[i][0].x, lines[i][0].y);
      
      for(var j = 0; j < lines[i].length-2; j++) {
        var xc = (lines[i][j].x + lines[i][j + 1].x) / 2;
        var yc = (lines[i][j].y + lines[i][j + 1].y) / 2;
        context.quadraticCurveTo(lines[i][j].x, lines[i][j].y, xc, yc);
      }
    
      context.quadraticCurveTo(lines[i][j].x, lines[i][j].y, lines[i][j + 1].x, lines[i][j + 1].y);
      context.save();
    //   context.globalCompositeOperation = 'destination-out';
      context.fill();
      context.restore();
      context.stroke();
    }
        
        
         dataURL = canvas.toDataURL();
        
    });
        
    
    
    </script>
    
    <style>
        .frame{
        width: 400px;
            height:600px;
            margin:0;
            padding: 0;
        background: "#fff";
        display:none;
        
        }
        .canvas{
             margin:0;
            padding:0;
    }
        
    
        
    </style>
    
    
    {#if inSVG}
    <g>
    <rect width="100%" height="100%" fill="black"/>
    <image xlink:href="{dataURL}" width="100%" height="100%" />
    </g>
    {:else}
    <img src="{dataURL}" width="{w}" height="{h}" />
    {/if}
